import { feedbackAPIModel } from 'src/app/models/api.model'

export interface feedbackState {
  details: feedbackAPIModel
}

export const initialFeedbackState: feedbackState = {
  details: undefined
}
